import ptBR from './locales/pt-BR'

export type MessageId = keyof (typeof messages)[keyof typeof messages]

const messages = {
  'pt-BR': ptBR
} as const

export default messages
